import { TabFilter } from './TabFilter';

export default TabFilter;
